import { schema } from 'normalizr';

export const partSchema = new schema.Entity(
  'parts',
  {},
  {
    idAttribute: 'uuid',
  },
);

export const shareSchema = new schema.Entity('shares');
